import { Controller } from "@hotwired/stimulus";

// Shows a progress bar and disables the form fieldset while the search form
// is mid-submit. Tied to the form's Turbo submit lifecycle, so there is no
// dependence on a server-side cable broadcast to clear the loading state.
export default class ReservationsSearchController extends Controller {
  static targets = ["loading", "fieldset", "submit"];

  connect() {
    this.start = this.start.bind(this);
    this.end = this.end.bind(this);
    this.element.addEventListener("turbo:submit-start", this.start);
    this.element.addEventListener("turbo:submit-end", this.end);
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-start", this.start);
    this.element.removeEventListener("turbo:submit-end", this.end);
    this.end();
  }

  start() {
    if (this.hasLoadingTarget) this.loadingTarget.hidden = false;
    if (this.hasFieldsetTarget) this.fieldsetTarget.disabled = true;
    if (this.hasSubmitTarget) this.submitTarget.disabled = true;
  }

  end() {
    if (this.hasLoadingTarget) this.loadingTarget.hidden = true;
    if (this.hasFieldsetTarget) this.fieldsetTarget.disabled = false;
    if (this.hasSubmitTarget) this.submitTarget.disabled = false;
  }
}
